// extracted by mini-css-extract-plugin
export var banner = "_o4-0";
export var settingRow = "_o4-2";
export var titleIcon = "_o4-1";